<div [ngClass]="groupClassName">
  <button
    *ngFor="let button of seDataButtons"
    (click)="doAction(button)"
    type="button"
    [ngClass]="className(button)">
    {{ button.label }}
    <se-spinner
      class="se-dialog-button__spinner"
      se-data-size="500">
    </se-spinner>
  </button>
</div>
